import { render, staticRenderFns } from "./editRecords.vue?vue&type=template&id=93bd7676"
import script from "./editRecords.vue?vue&type=script&lang=js"
export * from "./editRecords.vue?vue&type=script&lang=js"
import style0 from "./editRecords.vue?vue&type=style&index=0&id=93bd7676&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports